/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Budget_NoneInputs */

const en_ai_budget_none = /** @type {(inputs: Ai_Budget_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

const de_ai_budget_none = /** @type {(inputs: Ai_Budget_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Limit`)
};

/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Ai_Budget_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_budget_none = /** @type {((inputs?: Ai_Budget_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Budget_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_budget_none(inputs)
	return en_ai_budget_none(inputs)
});